import React from 'react';
import * as Sentry from "@sentry/react";
import { Helmet } from 'react-helmet';
import 'styles/react-kanban.css';
import { withToastManager } from 'react-toast-notifications';
import H1 from 'components/H1';
import H2 from 'components/H2';
import { Link } from 'react-router-dom';
import { Flex, Box, Button } from 'rebass';
import { Input, Label, Textarea, Select, Checkbox } from '@rebass/forms';
import StudyPageSubNav from 'components/Study/StudyPageSubNav';
import LoadingIndicator from 'components/LoadingIndicator';
import LoadingWrapper from 'components/LoadingIndicator/LoadingWrapper';
import ReactTooltip from 'react-tooltip';
import TooltipIcon from 'components/TooltipIcon';
import config from 'config';
import helpers from 'utils/helpers';
import helpersScreener from 'utils/helpers-screener';
import moment from 'moment-timezone';
import { FiLink, FiEdit, FiPlayCircle, FiCopy, FiEye, FiFileText, FiMail, FiSettings, FiType, FiPieChart, FiArrowRight, FiExternalLink, FiArrowUp } from 'react-icons/fi';

import EventEmitter from 'utils/events';
import BreadcrumbDivider from 'components/Breadcrumb/BreadcrumbDivider';
import { HeaderSubnavButton } from 'components/Header/HeaderSubnavButton';
import VariablesHelper from 'components/EmailTools/VariablesHelper';
import EmailEditor from 'components/EmailTools/EmailEditor';
import AppPageWrapper from 'components/AppPageWrapper';
import AppPageSubnav from 'components/AppPageWrapper/AppPageSubnav';
import AppPageBreadcrumbs from 'components/AppPageWrapper/AppPageBreadcrumbs';
import AppPageWrapperSectionHeader from 'components/AppPageWrapper/AppPageWrapperSectionHeader';
import AppPageWrapperSectionBody from 'components/AppPageWrapper/AppPageWrapperSectionBody';
import AppPageWrapperSectionSubHeader from 'components/AppPageWrapper/AppPageWrapperSectionSubHeader';
import { CollapsibleContentContainer } from 'components/CollapsibleContent';
import { ReactFormBuilder } from 'components/ReactFormBuilder';
import ScreenerTranslationComponent from 'components/ScreenerTranslationComponent';
import {
    COL_EMAIL,
    SCREENER_STUDY_ONLY,
    SCREENER_ANYONE,
    SCREENER_INTERNAL_ONLY,
    SCREENER_INACTIVE
} from 'utils/constants';

import xhr from 'xhr.js';
import auth from 'services/auth';
import services from 'services/services';
import studies_service from 'services/studies';
import ReactFormBuilder_store from 'components/ReactFormBuilder/stores/store';

class StudyScreenerIndividual extends React.Component {
    constructor(props) {
        super(props);

        this.tab_screener_builder = 'screener-builder';
        this.tab_screener_email = 'bulk-screener-email';
        this.tab_screener_configuration = 'screener-configuration';
        this.tab_screener_redirect = 'screener-redirect';

        this.state = {
            loading: true,
            study: {
                title: '',
                description: '',
                screener: []
            },
            screener: {
                links: []
            },
            screener_translation: null,
            editorData: null,
            available_columns: [],
            page_tabs: [
                { title: 'Screener Builder', label: this.tab_screener_builder, icon: <FiFileText /> },
                { title: 'Redirects & Language', label: this.tab_screener_redirect, icon: <FiType /> },
                { title: 'Bulk Screener Email', label: this.tab_screener_email, icon: <FiMail /> },
                { title: 'Screener Settings', label: this.tab_screener_configuration, icon: <FiSettings /> }
            ],
            page_tab_selected: this.tab_screener_builder,
            should_warn_no_email_sync: false
        };

        this.handleTranslationChange = this.handleTranslationChange.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.onChangeEditor = this.onChangeEditor.bind(this);
        this.removeCustomLink = this.removeCustomLink.bind(this);
        this.setCustomLink = this.setCustomLink.bind(this);
    }

    setPageTab(tab) {
        //if (tab != this.tab_screener_builder) {
            //console.log('getting screener...')
            this.getScreener();
        //}
        this.setState({ page_tab_selected: tab });
    }

    getCustomDataColumnsXHR(cb) {
        const { toastManager } = this.props;
        services
            .getCustomDataColumnsXHR()
            .then(available_columns => {
                this.setState({ available_columns });

                cb();
            })
            .catch(error => {
                let errorText = services.parseXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    onChangeEditor(editor, editorData) {
        this.onFormChange({ target: { value: editorData, name: 'email_screener_body' } });
    }

    onFormChange(e) {
        //console.log('PARENT FORM CHANGE', e);
        const { toastManager } = this.props;
        if (!e.target.name) {
            return;
        }

        if (e.target.name == 'participant_external') {
            // if we allow non-panelists to take the screener we need to create profiles for them
            // this means requiring an email
            if (e.target.value == 1) {
                let found_email_question = false;
                //console.log('allow!');
                // verify that there is an email-mapped question in the screener
                const email_custom_column = this.state.available_columns.find(column => column.title == COL_EMAIL);
                //console.log(this.state.available_columns, email_custom_column)
                if (email_custom_column) {
                    // find a screener question that maps to this
                    this.state.screener.form.forEach(screener_page_questions => {
                        screener_page_questions.forEach(question => {
                            //console.log(question.label, question)
                            if (question.personCustomDataId == email_custom_column.id
                                && question.save_to_panel == true
                                && question.required == true) {
                                found_email_question = true;
                            }
                        })
                    })
                }

                if (!found_email_question) {
                    const errorMsg = 'In order to allow Anyone to take the screener, please (1) Create a question in your screener asking for their email, (2) require it, and (3) enable "Save answers to the participant profile = Email".';
                    toastManager.add(errorMsg, {
                        appearance: 'error',
                        autoDismiss: true
                    });
                    return;
                }
            }
        }

        const screener = { ...this.state.screener };

        if (['verify_email'].includes(e.target.name)) {
            screener[e.target.name] = e.target.checked ? 1 : 0;
        } else {
            screener[e.target.name] = e.target.value;
        }

        this.setState({ screener }, () => {
            this.saveScreener();

            if (e && e.target && e.target.name == 'email_screener_body') {
                //console.log('here1');
                const editorData = this.formatEditorData(e.target.value);
                this.setState({ editorData: editorData });
            }
        });

    }

    saveScreener(){
        const { toastManager } = this.props;

        // detect change, and clear timeout if exists
        if (this.saveDelay) {
            clearTimeout(this.saveDelay);
        }

        this.saveDelay = setTimeout(() => {
            studies_service
                .updateScreener(this.state.screener.study_id, this.state.screener.id, this.state.screener)
                .then(() => {
                    /* toastManager.add('Saved', {
                        appearance: 'success',
                        autoDismiss: true
                    }); */
                })
                .catch(error => {
                    const errorText = services.parseXhrErrors(error);

                    toastManager.add(errorText, {
                        appearance: 'error',
                        autoDismiss: true
                    });
                });
        }, 500);
    }

    handleTranslationChange(e) {
        const { screener } = this.state;
        screener.screener_translation[e.target.name] = e.target.value;

        console.log(screener.screener_translation[e.target.name])

        this.setState({ screener }, () => {
            this.saveScreener();
        });
    }

    onSwitchChange(e) {
        console.log(e);

        const study = { ...this.state.study };
        const newStatus = study.status == 'active' ? 'paused' : 'active';

        console.log(newStatus);

        study.status = newStatus;
        this.setState({ study });

        this.updateStatusXhr(newStatus);
    }

    formatEditorData(editor_data) {
        return helpers.isObject(editor_data)
                    ? editor_data
                    : helpers.makeBlocksFromText(editor_data);
    }

    getScreenerFormSaveUrl(screener) {
        const url = `/studies/${this.props.match.params.study_id}/screeners/${this.props.match.params.screener_id}/form?account_id=${this.props.auth.account.id}&form_updated_at=${screener.form_updated_at}`;
        //console.log('getting new url...', url)
        return url;
    }

    emitUpdatedFormSaveUrl(screenerObject) {
        ReactFormBuilder_store.dispatch('updateSaveUrl', this.getScreenerFormSaveUrl(screenerObject));
    }

    componentDidMount() {
        const that = this;
        EventEmitter.subscribe('screener.save.success', (screenerObject) => {
            //console.log('screener.save.success', 'ping!')
            that.emitUpdatedFormSaveUrl(screenerObject);
            this.checkForEmailIfAnyone(screenerObject);
        });
        EventEmitter.subscribe('screener.save.error', (error) => {
            //console.log('screener.save.error', error)
            const { toastManager } = this.props;
            const errorText = services.parseXhrErrors(error);

            toastManager.add(errorText, {
                appearance: 'error',
                autoDismiss: false
            });
        });
        EventEmitter.subscribe('screener.save.slow', (error) => {
            const { toastManager } = this.props;
            const warningText = 'Saving screener took longer than usual, this may be your "upload" internet connection. If you keep seeing errors, please restart your internet.';

            toastManager.add(warningText, {
                appearance: 'warning',
                autoDismiss: true
            });
        });

        this.getStudy();

        // we should get the columns first, as they're a prerequisite to building the screener
        this.getCustomDataColumnsXHR(() => {
            this.getScreener();
        });
    }

    getStudy() {
        xhr.get(`/studies/${this.props.match.params.study_id}?account_id=${this.props.auth.account.id}`, {
            withCredentials: true
        }).then(res => {
            const study = res.data;
            //console.log('getStudy', study)
            this.setState({
                study,
                loading: false
            });
        });
    }

    getScreener() {

        studies_service
            .getScreener(this.props.match.params.study_id, this.props.match.params.screener_id)
            .then(screener => {
                //setScreeners(screeners);
                //setIsLoading(false);
                //console.log(screener.form_updated_at)
                const editorData_xhr = this.formatEditorData(screener.email_screener_body);

                this.emitUpdatedFormSaveUrl(screener);

                ReactFormBuilder_store.dispatch('updateOrder', { elements: screener.form, saveData: false });

                this.setState({
                    screener,
                    editorData: editorData_xhr
                }, () => {
                    this.checkForEmailIfAnyone(screener);
                });
            })
            .catch(error => {

            });
    }

    removeCustomLink() {
        const { toastManager } = this.props;
        const isConfirmed = confirm('Are you sure you want to permanently delete this link? If you shared this link with anyone, they will no longer be able to access this screener.');
        if (isConfirmed) {
            studies_service
                .deleteScreenerCustomLink(this.state.screener.study_id, this.state.screener.id)
                .then((custom_links) => {
                    toastManager.add('Removed custom link', {
                        appearance: 'success',
                        autoDismiss: true
                    });
                    let screener = this.state.screener;
                    screener.links = custom_links;
                    this.setState({screener});
                })
                .catch(error => {
                    const errorText = services.parseXhrErrors(error);

                    toastManager.add(errorText, {
                        appearance: 'error',
                        autoDismiss: true
                    });
                });
        } else {
            console.log('not deleting');
        }
    }

    setCustomLink() {
        const { toastManager } = this.props;
        const newLink = prompt('What would you like the link to be?');
        if (newLink) {
            studies_service
                .setScreenerCustomLink(this.state.screener.study_id, this.state.screener.id, newLink)
                .then((custom_links) => {
                    toastManager.add('Added custom link', {
                        appearance: 'success',
                        autoDismiss: true
                    });
                    let screener = this.state.screener;
                    screener.links = custom_links;
                    this.setState({screener});
                })
                .catch(error => {
                    const errorText = services.parseXhrErrors(error);

                    toastManager.add(errorText, {
                        appearance: 'error',
                        autoDismiss: true
                    });
                });
        }
    }

    checkForEmailIfAnyone(screener) {
        //console.log('checkForEmailIfAnyone running', screener)
        let should_warn_no_email_sync = false;
        if (screener && SCREENER_ANYONE == screener.participant_external) {
            should_warn_no_email_sync = true;
            const email_custom_column = this.state.available_columns.find(column => column.title == COL_EMAIL);
            //console.log('for anyone..', email_custom_column)
            screener.form.forEach(screener_page_questions => {
                screener_page_questions.forEach(question => {
                    if (question.required == true && question.save_to_panel == true && email_custom_column && question.personCustomDataId == email_custom_column.id) {
                        //console.log('found email sync')
                        should_warn_no_email_sync = false;
                    }
                });
            });
        }
        //console.log('should_warn_no_email_sync', should_warn_no_email_sync)
        this.setState({should_warn_no_email_sync: should_warn_no_email_sync});
        //return should_warn_no_email_sync;
    }

    componentDidCatch(error, errorInfo) {
        Sentry.captureException(error);
    }

    render() {
        //console.log('StudyScreenerIndividual rendering...');
        const screener_link = helpersScreener.getScreenerCustomLink(this.state.screener, this.props.auth.account);
        const preview_screener_button = (
            <a href={`${screener_link}?is_preview=1`} target="_blank">
                <Button
                    variant="secondary-gray"
                    mr={0}
                >
                    <FiEye/>Preview Screener
                </Button>
            </a>
        );

        return (
            <Flex style={{ width: '100%' }}>
                <AppPageWrapper>
                    <Helmet>
                        <title>{this.state.study.title} - Screener</title>

                        {/* <link
                            rel="stylesheet"
                            href="https://cdn.jsdelivr.net/npm/bootstrap@4.5.3/dist/css/bootstrap.min.css"
                            integrity="sha384-TX8t27EcRE3e/ihU7zmQxVncDAy5uIKz4rEkgIXeMed4M0jlfIDPvg6uqKI2xXr2"
                            crossOrigin="anonymous"
                        /> */}
                    </Helmet>


                    <AppPageSubnav>
                        <AppPageBreadcrumbs items={[
                            { url: `/studies`, title: `Studies`},
                            { url: `/studies/${this.props.match.params.study_id}`, title: this.state.study.title},
                            { url: `/studies/${this.props.match.params.study_id}/screeners`, title: `Screeners`},
                            { url: null, title: this.state.screener.title},
                        ]}>
                        </AppPageBreadcrumbs>
                    </AppPageSubnav>
                    <Flex sx={{ flexDirection: 'row' }} px={4} className='tertiary-nav tertiary-nav-padded'>
                        {this.state.page_tabs.map(pt => {
                            return <HeaderSubnavButton style={{padding: '0 0 8px 0'}} className={this.state.page_tab_selected == pt.label && 'active'} onClick={() => this.setPageTab(pt.label)}>
                                <div className='subnav-primary'>{pt.icon}{pt.title}</div>
                            </HeaderSubnavButton>
                        })}
                    </Flex>

                    <AppPageWrapperSectionBody style={{background: this.state.page_tab_selected == this.tab_screener_builder ? '#f6f6f6' : '#fff'}}>
                        {this.state.loading ? (
                            <div style={{ width: '100%' }}>
                                <LoadingWrapper>
                                    <LoadingIndicator />
                                </LoadingWrapper>
                            </div>
                        ) : (
                            <Flex mt={3} style={{ width: '100%' }}>
                                <Box mx={4} style={{ width: '100%' }}>

                                    {this.state.page_tab_selected == this.tab_screener_configuration &&
                                        <Flex mb={3} className='form-wrapper' style={{ width: '100%' }}>
                                            <Box width={1/3} mb={2}>
                                                <H2>Basic Details</H2>
                                                <Label className='quiet thin'>
                                                    This information will not be public.
                                                </Label>
                                            </Box>
                                            <Box width={2/3} mb={4} sx={{flexWrap: 'wrap', display: 'flex'}}>
                                                <Box width={1/3} className='form-label'>
                                                    Internal Title
                                                </Box>
                                                <Box width={2/3} className='form-data'>
                                                    <Input type="text" name="title" value={this.state.screener.title} onChange={this.onFormChange} />
                                                </Box>
                                                <Box width={1/3} className='form-label'>
                                                    Internal Description
                                                </Box>
                                                <Box width={2/3} className='form-data'>
                                                    <Textarea name='description' value={this.state.screener.description} onChange={this.onFormChange} />
                                                </Box>

                                                <Box width={1/3} className='form-label'>
                                                    Who can take the screener?
                                                </Box>
                                                <Box width={2/3} className='form-data'>
                                                    <Select
                                                        name="participant_external"
                                                        value={this.state.screener.participant_external}
                                                        onChange={this.onFormChange}
                                                        sx={{maxWidth: '320px'}}
                                                        mb={3}
                                                    >
                                                        <option value={SCREENER_STUDY_ONLY}>Study Participants</option>
                                                        <option value={SCREENER_ANYONE}>Anyone (even people outside my panel)</option>
                                                        <option value={SCREENER_INTERNAL_ONLY}>Private (internal-facing screener)</option>
                                                        <option value={SCREENER_INACTIVE}>Nobody (screener inactive)</option>
                                                    </Select>

                                                    {[SCREENER_ANYONE, SCREENER_STUDY_ONLY].includes(parseInt(this.state.screener.participant_external)) &&
                                                        <Box fontSize={1} mb={3}>
                                                            <Label>
                                                                <Checkbox
                                                                    name="verify_email"
                                                                    checked={this.state.screener.verify_email == 1}
                                                                    onChange={this.onFormChange}
                                                                />
                                                                <span className='checkbox-label'>
                                                                    Respondents should verify their email on "personal" screener links
                                                                    <TooltipIcon for={`verify_email-tooltip`} margin="3px 0 0 8px" />
                                                                </span>
                                                            </Label>
                                                            <ReactTooltip id={`verify_email-tooltip`} effect="solid" place="top">
                                                                <Box>
                                                                    At the start of the screener, respondents will be<br/>
                                                                    prompted to type in their email for verification.<br/>
                                                                    They will not be able to proceed if they type an<br/>
                                                                    email which does not match their panel profile.
                                                                </Box>
                                                            </ReactTooltip>
                                                        </Box>
                                                    }
                                                </Box>
                                            </Box>
                                            {this.state.screener.participant_external == SCREENER_ANYONE &&
                                                <>
                                                    <Box width={1/3} mb={4}>
                                                        <H2>Social Sharing</H2>
                                                        <Label className='quiet'>
                                                            Share your screener link on Facebook or Twitter, and this is how
                                                            it will appear.
                                                        </Label>
                                                    </Box>
                                                    <Box width={2/3} mb={4} sx={{flexWrap: 'wrap', display: 'flex'}}>
                                                        <Box width={1/3} className='form-label'>
                                                            Public Title
                                                        </Box>
                                                        <Box width={2/3} className='form-data'>
                                                            <Input type="text" name="public_title" value={this.state.screener.public_title} onChange={this.onFormChange} />
                                                        </Box>
                                                        <Box width={1/3} className='form-label'>
                                                            Public Description
                                                        </Box>
                                                        <Box width={2/3} className='form-data'>
                                                            <Textarea name='public_description' value={this.state.screener.public_description} onChange={this.onFormChange} />
                                                        </Box>
                                                        <Box width={1/3} className='form-label'>
                                                            Public Link
                                                        </Box>
                                                        <Box width={2/3} className='form-data'>
                                                            <Flex fontSize={1} mb={1} sx={{width: '100%'}} className='mimic-theme rounded'>

                                                                <Box p={2} sx={{borderRight: '1px solid #eee', flexShrink: 0}}>
                                                                    <FiLink style={{margin: '9px 8px 7px', fontSize: '16px', color: '#777'}} />
                                                                </Box>

                                                                <Box className='ellipsis quiet' sx={{padding: '14px 16px 12px', flexGrow: 1}}>
                                                                    <a href={screener_link} target="_blank" className='quiet'>
                                                                         {screener_link}
                                                                    </a>
                                                                </Box>

                                                                <Box p={2} sx={{flexShrink: 0}}>

                                                                    {/*<Button
                                                                        variant="secondary-gray"
                                                                        ml={2}
                                                                        mr={0}
                                                                        onClick={(e) => {
                                                                            this.setState({editCustomLink: true})
                                                                        }}
                                                                    >
                                                                        Edit
                                                                    </Button>*/}

                                                                    <Button
                                                                        variant="primary"
                                                                        mr={0}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            const { toastManager } = this.props;
                                                                            helpers.copyToClipboard(screener_link);
                                                                            toastManager.add('Copied link', {
                                                                                appearance: 'success',
                                                                                autoDismiss: true
                                                                            });
                                                                        }}
                                                                    >
                                                                        <FiCopy/> Copy
                                                                    </Button>
                                                                </Box>
                                                            </Flex>
                                                            <Box>
                                                                {this.state.screener.links.length > 0 ?
                                                                    <Button variant='link' fontSize={1}
                                                                        className='quiet'
                                                                        onClick={this.removeCustomLink}>
                                                                        <u>Remove custom link "{this.state.screener.links[0].slug}"</u>
                                                                    </Button>
                                                                    :
                                                                    <Button variant='link' fontSize={1}
                                                                        className='quiet'
                                                                        onClick={this.setCustomLink}>
                                                                        <u>Create custom link</u>
                                                                    </Button>
                                                                }
                                                                {helpers.newFeatureTag(moment("10-28-2021", "MM-DD-YYYY"), {margin: '7px 0 0 8px'})}
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </>
                                            }

                                            <Box width={1/3}>
                                                <H2>Automatic Scheduling</H2>
                                                <Label className='quiet'>
                                                    You can forward the qualified participant to schedule themselves,
                                                    based on the Study availability.
                                                </Label>
                                            </Box>
                                            <Box width={2/3} mb={4} sx={{flexWrap: 'wrap', display: 'flex'}}>
                                                <Box width={1/3} className='form-label'>

                                                </Box>
                                                <Box width={2/3} className='form-data'>
                                                    <Select
                                                        name="participant_schedule"
                                                        value={this.state.screener.participant_schedule}
                                                        onChange={this.onFormChange}
                                                        sx={{maxWidth: '360px'}}
                                                        mb={4}
                                                    >
                                                        <option value="automatic">
                                                            Automatically allow them to schedule themselves
                                                        </option>
                                                        <option value="manual">Wait for me to send them a scheduling email</option>
                                                    </Select>
                                                </Box>
                                            </Box>
                                        </Flex>
                                    }

                                    {this.state.page_tab_selected == this.tab_screener_builder &&
                                        <Box style={{width:'100%', minHeight: '560px'}}>

                                            {this.state.should_warn_no_email_sync == true &&
                                                <Box className='label-red rounded' fontSize={1} p={3} style={{position: 'sticky', top: 0, zIndex: 1000}}>
                                                    This screener can be taken by <u>Anyone</u> but "Email Two-way sync" is missing. To fix, create an "Email" question, click require, click on the "Two-way sync" checkbox, and select "Email" from the dropdown.
                                                </Box>
                                            }
                                            {this.state.screener && this.state.screener.id &&
                                                <Box sx={{position: 'relative'}}>
                                                    <ReactFormBuilder
                                                        uuid={this.state.screener.uuid}
                                                        data={this.state.screener.form}
                                                        saveUrl={this.getScreenerFormSaveUrl(this.state.screener)}
                                                        read_only={1}
                                                        page_logic={this.state.screener.page_logic}
                                                        form_updated_at={this.state.screener.form_updated_at}
                                                    />
                                                    <Button
                                                        variant="circle"
                                                        sx={{ position: 'fixed', bottom: '32px', right: '32px' }}
                                                        onClick={e => {
                                                            helpers.scrollToTop();
                                                        }}
                                                    >
                                                        <FiArrowUp style={{fontSize: '29px', strokeWidth: '1px'}} />
                                                    </Button>
                                                </Box>
                                            }

                                            {/*<Box className='border' p={4} fontSize={1}>
                                                <H2>Screener FAQ</H2>
                                                <Box mt={3}>
                                                    <Label className=''>How to use simple piping?</Label>
                                                    <Box>
                                                        To show an answer from a previous question in a future question or option,
                                                        use the pattern &#123;pg=#,q=#&#125;.<br/>
                                                        <em>Example: What do you like about &#123;pg=1,q=1&#125;?</em><br/>
                                                        <em>Example: Why did you choose &#123;pg=2,q=3&#125;?</em>
                                                    </Box>
                                                </Box>
                                                <Box mt={4}>
                                                    <Label className=''>How do qualification & disqualification work?</Label>
                                                    <Box>
                                                        Qualification logic executes at the end of a page. If a person submits
                                                        a disqualifying answer, and there are more questions on the same page,
                                                        nothing will happen until "Next" or "Submit" are clicked.
                                                    </Box>
                                                </Box>
                                            </Box>*/}

                                        </Box>

                                    }

                                    {this.state.page_tab_selected == this.tab_screener_redirect &&
                                        <Flex mb={3} className='form-wrapper' style={{ width: '100%', flexDirection: 'column' }}>

                                            {this.state.screener.screener_translation && (
                                                <ScreenerTranslationComponent screener_translation={this.state.screener.screener_translation} handleTranslationChange={this.handleTranslationChange}/>
                                            )}
                                        </Flex>
                                    }

                                    {this.state.page_tab_selected == this.tab_screener_email &&
                                        <Flex mb={3} className='form-wrapper' style={{ width: '100%', flexDirection: 'column' }}>
                                            <Flex mb={3} sx={{gridGap: 4, width: '100%'}}>
                                                <Box width={1/2}>
                                                    <Label>Preview your email</Label>
                                                    <Button
                                                        variant="secondary"
                                                        sx={{ width: '100%' }}
                                                        onClick={e => {
                                                            e.stopPropagation();
                                                            helpers.popupWindow({
                                                                url: `${config.API_URL}/studies/${this.props.match.params.study_id}/screeners/${this.props.match.params.screener_id}/email-preview?account_id=${this.state.study.account_id}`,
                                                                w: 800,
                                                                h: 600
                                                            });
                                                        }}
                                                    >
                                                        <FiPlayCircle /> Preview Email
                                                    </Button>
                                                </Box>
                                                <Box width={1/2}>
                                                    <VariablesHelper
                                                        elementId="email_screener_body"
                                                        content={this.state.screener.email_screener_body}
                                                        onChange={val => {
                                                            this.onFormChange({
                                                                target: { value: val, name: 'email_screener_body' }
                                                            });
                                                        }}
                                                    />
                                                </Box>
                                            </Flex>

                                            <Label htmlFor="email_screener_subject" mb={2}>Email Subject</Label>
                                            <Input
                                                type="text"
                                                name="email_screener_subject"
                                                value={this.state.screener.email_screener_subject}
                                                onChange={this.onFormChange}
                                                placeholder="Email Subject"
                                            />

                                            <Label htmlFor="email_screener_body" mt={4} mb={2}>
                                                Email Body
                                            </Label>
                                            {/* <Textarea
                                                id="email_screener_body"
                                                name="email_screener_body"
                                                placeholder="Email Body"
                                                value={this.state.screener.email_screener_body}
                                                onChange={this.onFormChange}
                                                height="200px"
                                            /> */}

                                            {this.state.editorData && (
                                                <Box style={{width: '100%'}}>
                                                    <EmailEditor
                                                        editorData={this.state.editorData}
                                                        onChange={this.onChangeEditor}
                                                        allowScreenerButton={true}
                                                    />
                                                </Box>
                                            )}
                                        </Flex>
                                    }
                                    <br />
                                    <br />
                                    <br />
                                    <br />

                                    {/* <ul>
                                 <li>You can set up a "Web Intercept" below, to recruit users from a website.</li>
                                 <li>Recruiting via email campaigns coming soon (ie. like MailChimp).</li>
                             </ul>

                            <OnboardingScript auth={this.props.auth} /> */}

                                    {/* <H2>Select Recruiting Type</H2>
                            <Button>Create Intercept</Button>
                            <Button>Create Email Campaign</Button> */}

                                    {/* <div>
                                <h1>Results</h1>
                                     {JSON.stringify(this.state.screenerAnswers)}
                              </div> */}
                                </Box>
                            </Flex>
                        )}
                    </AppPageWrapperSectionBody>
                </AppPageWrapper>

            </Flex>
        );
    }
}

export default withToastManager(StudyScreenerIndividual);

/*
contact
--
first name
last name
email
phone


other
--
scheduling
magic drilldown
hidden external variable
image & text
formatted text block
opinion scale
qualifying question


close-ended
--
checkboxes
drop down
radio buttons
yes/no

open-ended
--
single line
paragraph
*/
